import { render, staticRenderFns } from "./ModifyOrder.vue?vue&type=template&id=a649d9c0"
import script from "./ModifyOrder.vue?vue&type=script&lang=js"
export * from "./ModifyOrder.vue?vue&type=script&lang=js"
import style0 from "./ModifyOrder.vue?vue&type=style&index=0&id=a649d9c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports